function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import { isBlank } from 'underscore.string';
import { canadianProvincesMapToShortened, countryMapToShortened, USStatesMapToShortened } from 'shared/core/constants/geography';
import { getCityToDisplay } from './address';
var parseStateShortCode = function(option1, option2) {
    var splitByDash = _.split(option1 || option2, '-');
    return splitByDash[splitByDash.length - 1];
};
var formatAddressForLocationSearch = function(location) {
    var ln1 = location.ln1, ln2 = location.ln2, state = location.state, stateLong = location.stateLong, zipcode = location.zipcode, country = location.country, countryLong = location.countryLong, rootType = location.rootType;
    var countryPretty = rootType === 'region' || rootType === 'country' ? countryLong : "".concat(country === 'US' ? 'USA' : country);
    var statePretty = rootType === 'place' || rootType === 'region' ? stateLong : state;
    var cityPretty = getCityToDisplay(location);
    return _.reject([
        _.reject([
            ln1,
            ln2
        ], isBlank).join(' '),
        cityPretty,
        _.reject([
            statePretty,
            zipcode
        ], isBlank).join(' '),
        countryPretty
    ], isBlank).join(', ');
};
/**
 * Builds a location object from a Mapbox feature response.
 * Handles NYC borough addresses where Mapbox returns locality (e.g., "Brooklyn")
 * separately from place (e.g., "New York"). In these cases, we prefer locality
 * for the city field to ensure correct delivery zone matching.
 */ export function buildLocationObjectFromMapboxFeature(data) {
    var id = data.id, center = data.center, addressLong = data.place_name;
    var _center = _sliced_to_array(center, 2), lng = _center[0], lat = _center[1];
    var locationDetails = _.reduce([
        _object_spread_props(_object_spread({}, data), {
            isRoot: true
        })
    ].concat(_to_consumable_array(data.context || [])), function(accumulator, current) {
        // eslint-disable-next-line camelcase
        var address = current.address, currentId = current.id, text = current.text, short_code = current.short_code, properties = current.properties;
        var __split = _sliced_to_array(_.split(currentId, '.'), 1), type = __split[0];
        if (current.isRoot) {
            accumulator.rootType = type;
        }
        if (type === 'country') {
            accumulator.country = countryMapToShortened[text];
            accumulator.countryLong = text;
        } else if (type === 'region') {
            var _USStatesMapToShortened_text, _ref;
            accumulator.state = (_ref = (_USStatesMapToShortened_text = USStatesMapToShortened[text]) !== null && _USStatesMapToShortened_text !== void 0 ? _USStatesMapToShortened_text : canadianProvincesMapToShortened[text]) !== null && _ref !== void 0 ? _ref : parseStateShortCode(short_code, properties === null || properties === void 0 ? void 0 : properties.short_code);
            accumulator.stateLong = text;
        } else if (type === 'postcode') {
            accumulator.zipcode = text;
        } else if (type === 'district') {
            accumulator.county = text;
        } else if (type === 'locality') {
            accumulator.locality = text;
        } else if (type === 'place') {
            accumulator.place = text;
        } else if (type === 'neighborhood') {
            accumulator.neighborhood = text;
        } else if (type === 'address') {
            // TODO: see if there's a way to get ln2 (Ex: Apt 111) in Mapbox
            accumulator.ln1 = "".concat(address ? "".concat(address, " ") : '').concat(text);
        }
        return accumulator;
    }, {});
    // For US addresses, prefer locality over place (NYC boroughs: locality="Brooklyn", place="New York").
    // For non-US addresses, prefer place over locality (Canada: place="St. Catharines", locality="Shipman" sub-community).
    // `place` is kept on the location object (in addition to the derived city) so backend
    // delivery-zone matching can fall back to it for township municipalities: Mapbox reports
    // a township address with locality "Little Falls Township" but place "Little Falls", and
    // the place name is exactly what dispensary admins pick when configuring a Cities/Towns
    // delivery zone.
    var place = locationDetails.place, restLocationDetails = _object_without_properties(locationDetails, [
        "place"
    ]);
    var isUS = locationDetails.country === 'US';
    var finalLocationDetails = _object_spread_props(_object_spread({}, restLocationDetails, place ? {
        place: place
    } : {}), {
        city: isUS ? locationDetails.locality || place : place || locationDetails.locality
    });
    return _object_spread_props(_object_spread({
        id: id
    }, finalLocationDetails), {
        lat: lat,
        lng: lng,
        address: formatAddressForLocationSearch(finalLocationDetails),
        addressLong: addressLong
    });
}
